import {IBaseLookup} from "./Ibase.lookup";

export namespace AccessControlList {

    export const lookupName: string = "AccessControlList";

    export interface Acl {
        aclKey: number;
        permittedUserPersonKey: number;
        patientPersonKey: number;
        orderKey: number;
        reportKey: number;
        requestedProcedureId: number;
        visitKey: number;
        lastUpdated: Date;
    }

    export interface AccessControlListDS extends IBaseLookup {
        acl: Acl[];
    }
}
